import React from 'react';
import { GiCancel } from '../../Data/Icons';
import {
	COMPRESSED_STOCK_IMAGE_URL,
	toast,
	axios,
	API_URL,
	formConfig,
	useState,
	Loader,
	config,
	useEffect,
} from '../../Data/Imports';

const ImageViewModal = ({ updateImageData, setUpdateImageData, handleReset, fetchProducts }) => {
	const [uploaded, setUploaded] = useState(false);
	const [stockImages, setStockImages] = useState([]);
	const [loading, setLoading] = useState(false);
	const handleFileChange = (event) => {
		const file = event.target.files[0];
		if (file) {
			const newImageURL = URL.createObjectURL(file);

			// Update the state with the new image preview
			setUpdateImageData((prev) => ({
				...prev,
				ImagePreview: newImageURL,
				ImageFile: file, // store actual file here
			}));
		}
	};

	useEffect(() => {
		const getAllStockImages = async () => {
			try {
				const response = await axios.post(
					`${API_URL}/stock/get/stock-images`,
					{ ProductId: updateImageData?.ProductId },
					config
				);
				setStockImages(response?.data?.stockImages);
			} catch (error) {
				setStockImages([]);
			}
		};
		getAllStockImages();
	}, [updateImageData?.ProductId]);

	const handleUpload = async () => {
		if (!updateImageData.ImageFile) return;
		try {
			setLoading(true);
			const response = await axios.post(
				`${API_URL}/stock/update/update-stock-image`,
				updateImageData,
				formConfig
			);

			toast.success(response?.data?.message);

			// Refresh stock list
			await fetchProducts();

			setUpdateImageData((prev) => ({
				...prev,
				ImagePreview: prev.ImagePreview,
				ImageFile: '',
				currentImagePath: '',
			}));
			setUploaded(true);
		} catch (error) {
			toast.error(error?.response?.data?.message || 'Something Went Wrong');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center gap-10 z-50'>
			{loading && (
				<div className='fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50'>
					<Loader />
				</div>
			)}
			<div className='bg-white p-4 rounded-lg shadow-lg relative'>
				<button
					className='absolute top-2 right-2 text-[#213555] hover:text-black'
					onClick={() => handleReset()}>
					<GiCancel size={24} />
				</button>
				{/* Image Preview */}
				<div className='flex flex-col items-center'>
					<img
						src={
							updateImageData.ImagePreview ||
							`${COMPRESSED_STOCK_IMAGE_URL}/${updateImageData.currentImagePath}`
						}
						alt='Product'
						className='max-w-[90vw] max-h-[80vh] object-contain'
					/>
				</div>
				{/* File Upload Section */}
				{!uploaded && (
					<div className='mt-4 flex justify-center items-center'>
						<input
							type='file'
							accept='image/*'
							onChange={handleFileChange}
							className='border p-2 rounded cursor-pointer'
						/>
						<button
							onClick={handleUpload}
							disabled={!updateImageData.ImageFile}
							className={`mt-2 px-4 py-2 rounded ${
								updateImageData.ImageFile ? 'globalButton' : 'bg-gray-300 cursor-not-allowed'
							} text-white`}>
							Upload
						</button>
					</div>
				)}
			</div>
			<div className='bg-white p-2 rounded-lg shadow-lg relative'>
				{stockImages?.map((stockImage, index) => (
					<div key={index} className=' my-5'>
						<img
							src={`${COMPRESSED_STOCK_IMAGE_URL}/${stockImage?.StockImages}`}
							alt='Product'
							className=' w-32  object-contain cursor-pointer	'
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default ImageViewModal;
